<template>
  <app-page-wrapper-grid class="checkout">
    <div class="iw-layout-grid__row checkout__row">
      <div class="iw-layout-grid__col--span-12">
        <back-button :route-to="{ name: ROUTE_NAMES.SHOPPING_CART }" /><span class="back-button-text p-l-10">Back to Cart</span>
      </div>
      <div class="iw-layout-grid__col--span-7">
        <div class="checkout__container">
          <h1>Checkout</h1>
        </div>

        <hr />
        <order-details :edit-enabled="true" />

        <hr v-show="showPaymentOptions" />

        <template
          v-if="!showPaymentOptions && (isFormSubmitted || ppiIssues || setupPaymentIssues || paymentGatewayError)"
          class="checkout__options"
        >
          <app-notifier v-for="(error, index) in errors" :key="index" type="failed" :data="error" />
        </template>

        <div v-show="showPaymentOptions" class="checkout__options" role="radiogroup" aria-label="Select Payment Method">
          <h2 class="checkout__options-title iw-group-title">Select Payment Method</h2>
          <div
            v-if="
              (getGatewayFavoriteCcs && getGatewayFavoriteCcs.length > 0) ||
              (getSavedAccountCards && getSavedAccountCards.length > 0)
            "
            class="checkout__options-favoriteCcs-options"
          >
            <h3 class="checkout__options-wallet-title">Your Wallet</h3>
            <div class="cc-wallet-cards">
              <user-credit-card
                v-for="cc in getGatewayFavoriteCcs"
                :key="cc.token"
                :card-holder="cc.holder"
                :expiration="cc.expiration"
                :last-four="cc.last4"
                :token="cc.token"
                :gateway-id="cc.gateway_id"
                :show-radio="true"
                :show-delete="false"
                @update:modelValue="handleSavedCreditCardChange"
              >
                <template v-if="selectedUserCard.tokenCard === cc.token">
                  <div v-if="walletCardError !== ''" class="error-container">
                    <img :src="require(`@/assets/images/warning.svg`)" class="warning-image" alt="" />
                    <p role="alert" class="error-message">{{ walletCardError }}</p>
                  </div>
                  <div v-if="paymentIFrame && selectedPayType === STORED_CREDIT_CARD" class="wallet-card-content">
                    <FPIframe
                      :payment-i-frame="paymentIFrame"
                      :payment-key-event-handler="FPPaymentKeyEventHandler"
                      :error-handler="FPIFrameErrorCallback"
                      :payment-type="selectedPayType"
                    >
                    </FPIframe>
                  </div>
                </template>
              </user-credit-card>
            </div>
            <hr
              v-if="
                getGatewayFavoriteCcs &&
                getGatewayFavoriteCcs.length > 0 &&
                getSavedAccountCards &&
                getSavedAccountCards.length > 0
              "
            />
            <div class="account-wallet-cards">
              <user-credit-card
                v-for="cc in getSavedAccountCards"
                :key="cc.token"
                :card-holder="cc.holder"
                :expiration="cc.expiration"
                :last-four="cc.last4"
                :token="cc.token"
                :gateway-id="cc.gateway_id"
                :show-radio="true"
                :show-delete="false"
                @update:modelValue="handleSavedCreditCardChange"
              >
                <div
                  v-if="selectedUserCard.tokenCard === cc.token && selectedPayType === STORED_ACCOUNT_CARD"
                  class="wallet-card-content"
                >
                  <div v-if="walletCardError !== ''" class="error-container">
                    <img :src="require(`@/assets/images/warning.svg`)" class="warning-image" alt="" />
                    <p role="alert" class="error-message">{{ walletCardError }}</p>
                  </div>
                  <tender-card-input
                    :key="cc.token"
                    :token="cc.token"
                    :payment-type="CAMPUS_ACCOUNT_MAP[cc.gateway_id]?.paymentType"
                    :subpayment-type="+cc.gateway_id"
                    :show-save-account="false"
                    :show-account="false"
                    @cardApplied="cardApplied"
                  />
                </div>
              </user-credit-card>
            </div>
            <hr />
          </div>
          <h3 v-if="favoriteCcs && favoriteCcs.length > 0" class="checkout__options-wallet-title">New Payment Method</h3>
          <div v-show="isApplePayEnabled" class="checkout__options-option m-b-20">
            <div class="checkout__options-radio m-t-20">
              <app-radio-button
                :id="PAY_TYPE_APPLE_PAY"
                label="Apple Pay"
                group-name="paymentOptions"
                :model-value="PAY_TYPE_APPLE_PAY"
                :payload="PAY_TYPE_APPLE_PAY"
                image="Apple_Pay_Mark_RGB_041619.svg"
                @onChangeHandler="setSelectedPayType"
              />
            </div>
          </div>

          <div class="checkout__options-option m-b-20">
            <template v-if="isFormSubmitted || ppiIssues || setupPaymentIssues || paymentGatewayError">
              <app-notifier v-for="(error, index) in errors" :key="index" type="failed" :data="error" />
            </template>

            <div class="checkout__options-radio m-t-20 m-b-20">
              <app-radio-button
                :id="PAY_TYPE_CREDIT_DEBIT"
                label="Credit Card / Debit Card"
                group-name="paymentOptions"
                :model-value="isApplePayEnabled ? '' : PAY_TYPE_CREDIT_DEBIT"
                :payload="PAY_TYPE_CREDIT_DEBIT"
                image="icon-new-credit-card.svg"
                @update:modelValue="() => handleSavedCreditCardChange('')"
                @onChangeHandler="setSelectedPayType"
              />
            </div>

            <div
              v-if="selectedPayType === PAY_TYPE_CREDIT_DEBIT && !selectedUserCard && setupPaymentCompleted"
              class="checkout__options-content"
            >
              <template v-if="paymentIFrame">
                <FPIframe
                  :payment-i-frame="paymentIFrame"
                  :payment-key-event-handler="FPPaymentKeyEventHandler"
                  :error-handler="FPIFrameErrorCallback"
                  :payment-type="selectedPayType"
                  class="checkout__card"
                >
                </FPIframe>
                <div v-if="isLoggedIn" class="checkout__save-wallet m-t-10 m-b-10">
                  <label class="checkbox">
                    <span class="checkbox__input">
                      <input id="saveCc" v-model="saveCcFlag" type="checkbox" name="checkbox" />
                      <span class="checkbox__control">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                          <path
                            fill="none"
                            stroke="currentColor"
                            stroke-width="3"
                            d="M1.73 12.91l6.37 6.37L22.79 4.59"
                            class="Path"
                          />
                        </svg>
                      </span>
                    </span>
                    <span class="iw-body-text-large checkout__title" for="saveCc">Save to my wallet</span>
                  </label>
                </div>
              </template>
              <template v-if="!paymentIFrame && !setupPaymentIssues">
                <form class="checkout__card">
                  <template v-if="isFormSubmitted">
                    <app-notifier
                      v-for="(error, index) in fieldsValidation"
                      :key="`_${index}`"
                      class="checkout__error"
                      type="failed"
                      :data="error"
                      :show="error != null"
                    />
                  </template>
                  <div class="checkout__section checkout__section_column">
                    <app-input
                      id="ccnumber"
                      v-model.trim="v$.cardNumber.$model"
                      name="ccnumber"
                      autocomplete="cc-number"
                      label="Card Number"
                      checkout="true"
                      maxlength="16"
                      :has-error="v$.cardNumber.$error && isFormSubmitted && selectedPayType === PAY_TYPE_CREDIT_DEBIT"
                      class="checkout__input"
                      mask="################"
                    />
                  </div>
                  <div class="checkout__section checkout__section_column">
                    <app-input
                      id="nameoncard"
                      v-model.trim="v$.cardHolder.$model"
                      name="nameoncard"
                      autocomplete="cc-name"
                      label="Holder Name"
                      checkout="true"
                      :has-error="v$.cardHolder.$error && isFormSubmitted && selectedPayType === PAY_TYPE_CREDIT_DEBIT"
                      class="checkout__input"
                    />
                  </div>
                  <div class="checkout__wrap-section">
                    <div class="checkout__wrap-section_column">
                      <app-input
                        id="cc-exp"
                        v-model="v$.expDate.$model"
                        name="cc-exp"
                        autocomplete="cc-exp"
                        label="Exp. Date"
                        checkout="true"
                        maxlength="5"
                        placeholder="MM/YY"
                        :has-error="v$.expDate.$error && isFormSubmitted && selectedPayType === PAY_TYPE_CREDIT_DEBIT"
                        mask="##/##"
                        class="checkout__input"
                      />
                      <span v-if="v$.expDate.$error" class="expDate__error"> Invalid Expiration Date </span>
                    </div>
                    <div class="checkout__wrap-section_column">
                      <app-input
                        id="cvv2"
                        v-model="v$.cardEncoded.$model"
                        name="cvv2"
                        autocomplete="cc-csc"
                        label="CVV"
                        checkout="true"
                        maxlength="4"
                        placeholder="CVV"
                        :has-error="v$.cardEncoded.$error && isFormSubmitted && selectedPayType === PAY_TYPE_CREDIT_DEBIT"
                        mask="####"
                        class="checkout__input"
                      />
                    </div>
                    <div v-if="APIType === OAPI_API_TYPE" class="checkout__wrap-section_column">
                      <app-input
                        id="postal-code"
                        v-model="v$.zipCode.$model"
                        name="postal-code"
                        autocomplete="postal-code"
                        label="Zip Code"
                        checkout="true"
                        placeholder="Zip code"
                        :has-error="v$.zipCode.$error && isFormSubmitted && selectedPayType === PAY_TYPE_CREDIT_DEBIT"
                        class="checkout__input"
                      />
                    </div>
                  </div>
                  <div v-if="false" class="checkout__footer">
                    <p class="checkout__description">
                      CVV is a 3 or 4 digit code that appears in the signature area of your card
                    </p>
                  </div>
                  <div v-if="isLoggedIn && APIType === OAPI_API_TYPE" class="checkout__save-wallet m-t-10 m-b-10">
                    <label class="checkbox">
                      <span class="checkbox__input">
                        <input id="saveCc" v-model="saveCcFlag" type="checkbox" name="checkbox" />
                        <span class="checkbox__control">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                            <path
                              fill="none"
                              stroke="currentColor"
                              stroke-width="3"
                              d="M1.73 12.91l6.37 6.37L22.79 4.59"
                              class="Path"
                            />
                          </svg>
                        </span>
                      </span>
                      <span class="iw-body-text-large checkout__title" for="saveCc">Save to my wallet</span>
                    </label>
                  </div>
                </form>
              </template>
            </div>

            <div v-if="isGooglePayEnabled" class="checkout__options-radio m-t-20 m-b-20">
              <app-radio-button
                :id="PAY_TYPE_GOOGLE"
                group-name="paymentOptions"
                :payload="PAY_TYPE_GOOGLE"
                @onChangeHandler="setSelectedPayType"
              >
                <div class="checkout__googlePayContainer">
                  <img
                    class="checkout__image-googlePay"
                    :src="require('@/assets/images/' + 'google-pay-mark_800.svg')"
                    alt="customize"
                  />
                  <h4 class="iw-hyperlink">Google Pay</h4>
                </div>
              </app-radio-button>
            </div>
            <template v-if="paymentIFrame && selectedPayType === PAY_TYPE_GOOGLE">
              <FPIframe
                :payment-i-frame="paymentIFrame"
                :payment-key-event-handler="FPPaymentKeyEventHandler"
                :error-handler="FPIFrameErrorCallback"
                :payment-type="selectedPayType"
              >
              </FPIframe>
            </template>

            <tenders
              id="tenders"
              group-name="paymentOptions"
              :selected-pay-type="selectedPayType"
              @onChangeHandler="setSelectedPayType"
              @cardApplied="cardApplied"
            />
          </div>
        </div>
        <hr v-show="showPaymentOptions" />
      </div>

      <div class="iw-layout-grid__col--span-1"></div>

      <div class="iw-layout-grid__col--span-4">
        <div class="checkout__summary">
          <shopping-cart-total :cart-items="availableCartItems" :read-only="true" />
        </div>

        <div class="checkout__footer-links">
          <app-button
            id="checkoutCCBtn"
            text="Place Order"
            :aria-label="'Place Order'"
            :handler="checkout"
            class="checkout__button"
            :is-disabled="isDisabled"
          />
          <app-button
            v-show="false"
            id="checkoutAPBtn"
            ref="checkoutAPBtn"
            text="Place Order"
            :handler="() => null"
            class="checkout__button"
            :is-disabled="isDisabled"
          />
        </div>
      </div>
    </div>
  </app-page-wrapper-grid>
</template>
<!-- prettier-ignore -->
<script>
/* eslint-disable no-undef */
import { mapActions, mapGetters, mapMutations } from "vuex";
import vendorDialogMixin from "@/mixins/vendor-dialog.mixin";
import ShoppingCartTotal from "../shopping-cart/components/cart-total/ShoppingCartTotal";
import Tenders from "./components/tenders/Tenders";
import TenderCardInput from "./components/tenders/TenderCardInput.vue";
import FPIframe from "./components/FPIframe";
import UserCreditCard from "./components/UserCreditCard";
import BackButton from "../../components/buttons/back-button/BackButton.vue";

import {
  ERROR_PROCESSING_PPI_PAYMENTS,
  ERROR_PROCESSING_PAYMENT,
  CREDIT_CARD_PAYMENT_TYPE,
  PAY_TYPE_APPLE,
  PAY_TYPE_CREDIT_DEBIT,
  STORED_CREDIT_CARD,
  PAY_TYPE_GOOGLE,
  ERROR_APPLYING_PPI_TENDER,
  ERROR_AMENITY_ALREADY_APPLIED
} from "@/../app-constants";
import { roundOffByBankApproach, getMaskedCardNumber, FPIFrameValidation, trackCheckoutView, maskedCredential } from "@/utils";
import useVuelidate from "@vuelidate/core";
import { required, maxLength, minLength, numeric } from "@vuelidate/validators";
import {
  ELAVON_GATEWAY_ID,
  FREEDOMPAY_GATEWAY_ID,
  loadPaymentGatewayScripts,
  MAPI_API_TYPE,
  OAPI_API_TYPE,
  SENTRY_ERRORS,
  ROUTE_NAMES,
  STORED_ACCOUNT_CARD
} from "../../utils";
import errorLoggerAdapter from "@/adapters/errorLoggerAdapter";
import AppAppliedPaymentNotifier from "@/components/base/app-applied-payment-notifier/AppAppliedPaymentNotifier.vue";
import OrderDetails from "@/components/order-details/OrderDetails.vue";
import { CAMPUS_SUBPAYMENT_TYPES, CAMPUS_ACCOUNT_MAP } from "@appetize/iw-common/constants";

export const appliedPaymentMsg = (balanceDue) => `Payment Applied. Balance Due $${balanceDue.toFixed(2)}.`;

export const validExpDate = (value) => {
  const regexExpDate = /([0-9]+)\/([0-9]{2})/;

  if (!regexExpDate.test(value)) {
    return false;
  } else {
    const match = value.match(regexExpDate);
    // eslint-disable-next-line no-unused-vars
    let [_, month, year] = match;

    const fullYear = 2000 + parseInt(year, 10);
    month = parseInt(month, 10);

    const todayDate = new Date();
    const expDate = new Date(fullYear, month, 0);
    const maxYearDate = new Date(todayDate.setFullYear(todayDate.getFullYear() + 10));
    return expDate > new Date() && expDate < maxYearDate;
  }
};

export default {
  name: "Checkout",
  components: {
    FPIframe,
    ShoppingCartTotal,
    Tenders,
    TenderCardInput,
    UserCreditCard,
    BackButton,
    OrderDetails
  },
  mixins: [vendorDialogMixin],
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      cardNumber: "",
      expDate: "",
      cardEncoded: "",
      cardHolder: "",
      zipCode: "",
      errors: [],
      isFormSubmitted: false,
      ppiIssues: false,
      selectedPayType: PAY_TYPE_CREDIT_DEBIT,
      saveCcFlag: false,
      selectedUserCard: "",
      paymentIFrame: "",
      selectedSavedAccountTenders: [],
      setupPaymentCompleted: false,
      setupPaymentIssues: false,
      ROUTE_NAMES,
      walletCardError: ""
    };
  },
  validations() {
    const validations = {
      cardNumber: {
        required,
        minLength: minLength(13),
        maxLength: maxLength(16)
      },
      cardHolder: {
        required,
        minLength: minLength(2)
      },
      expDate: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(5),
        validExpDate
      },
      cardEncoded: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(4),
        numeric
      }
    };

    const zipCode = {
      required: required,
      minLength: minLength(5)
    };

    //We only validate zipCode for OAPI
    if (this.APIType === OAPI_API_TYPE) {
      return { ...validations, zipCode };
    }
    return validations;
  },
  computed: {
    ...mapGetters({
      // CART
      availableCartItems: "cart/getAvailableCartItems",
      cartItems: "cart/getCartItems",
      cartItemsSize: "cart/getCartSize",
      getAppliedAmenities: "cart/getAppliedAmenities",
      getAmenitiesInUse: "cart/getAmenitiesWithCardBalanceInUse",
      getCheckoutParams: "cart/getCheckoutParams",
      getInitElavonAP: "cart/getInitElavonAP",
      getPpiTotal: "cart/getPpiTotal",
      getProcessedAmenities: "cart/getProcessedAmenities",
      getCheckoutErrors: "cart/getCheckoutErrors",
      getURLpassTender: "cart/getURLpassTender",
      getPpiAmenities: "cart/getPpiAmenities",

      // payments
      getPaymentSessionToken: "payments/getPaymentSessionToken",

      // user
      isLoggedIn: "user/isLoggedIn",
      favoriteCcs: "user/getVisitorCreditCards",

      // vendor
      activeVendor: "vendor/getActiveVendor",
      tokenizedGatewayId: "vendor/tokenizedGatewayId",

      // venue
      venueId: "venue/getActiveVenue",

      // venue settings
      applePayEnabled: "venueSettings/applePayEnabled",
      APIType: "venueSettings/APIType",
      userData: "user/getUserData",
      guestUserData: "user/getGuestUserData",
      getTenders: "vendor/getTenders",
      rewardAutoLookup: "venueSettings/getRewardsAutoLookup",
      rewardProviders: "venueSettings/getRewardProviders"
    }),

    getExpDate() {
      return this.expDate.replace(/\//, "");
    },

    getGatewayFavoriteCcs() {
      if (!this.favoriteCcs) return [];
      return this.favoriteCcs?.filter((value) => parseInt(value.gateway_id) === this.tokenizedGatewayId);
    },

    getSavedAccountCards() {
      if (!this.favoriteCcs) return [];
      return this.favoriteCcs?.filter((value) => CAMPUS_SUBPAYMENT_TYPES.includes(parseInt(value.gateway_id)));
    },

    showPaymentOptions() {
      if (this.getAppliedAmenities.balance === 0) return false;
      return this.getAppliedAmenities.balance > 0 || this.errors.length;
    },

    paymentGatewayError(){
      return this.APIType === OAPI_API_TYPE && this.tokenizedGatewayId === 0;
    },

    fieldsValidation() {
      const errors = [];

      const fields = {
        cardNumber: "Invalid Card Number",
        cardHolder: "Invalid Holder Name",
        expDate: "Invalid Expiration Date",
        cardEncoded: "Invalid CCV"
      };

      for (const key in fields) {
        if (this.v$[key].required && this.v$[key].$invalid) errors.push(fields[key]);
      }

      return errors;
    },

    isApplePayEnabled() {
      return this.applePayEnabled && window.ApplePaySession && ApplePaySession.canMakePayments();
    },

    isGooglePayEnabled() {
      return this.APIType === OAPI_API_TYPE && this.tokenizedGatewayId === this.FREEDOMPAY_GATEWAY_ID;
    },

    isDisabled() {
      if (this.selectedPayType === this.PAY_TYPE_APPLE_PAY) return false;

      if (this.tokenizedGatewayId === this.FREEDOMPAY_GATEWAY_ID) {
        // payment issues, button disabled
        if (this.setupPaymentIssues) return true;
        return this.getAppliedAmenities?.balance > 0;
      }

      if (!this.showPaymentOptions || this.selectedUserCard) return false;
      return this.v$.$invalid;
    }
  },

  unmounted() {
    //We need to clean up errors on destroy.
    this.resetCheckoutErrors();
  },

  created() {
    // this is a hack so i can use the values in the template.
    this.PAY_TYPE_APPLE_PAY = PAY_TYPE_APPLE;
    this.PAY_TYPE_CREDIT_DEBIT = PAY_TYPE_CREDIT_DEBIT;
    this.PAY_TYPE_GOOGLE = PAY_TYPE_GOOGLE;
    this.OAPI_API_TYPE = OAPI_API_TYPE;
    this.ELAVON_GATEWAY_ID = ELAVON_GATEWAY_ID;
    this.FREEDOMPAY_GATEWAY_ID = FREEDOMPAY_GATEWAY_ID;
    this.STORED_CREDIT_CARD = STORED_CREDIT_CARD;
    this.STORED_ACCOUNT_CARD = STORED_ACCOUNT_CARD;
    this.CAMPUS_ACCOUNT_MAP = CAMPUS_ACCOUNT_MAP;
  },

  mounted() {
    this.loadGatewayScripts();

    this.selectedPayType = this.isApplePayEnabled ? this.PAY_TYPE_APPLE_PAY : this.PAY_TYPE_CREDIT_DEBIT;
    this.setupPayment(this.selectedPayType);
    this.processPPIPayment(this.getURLpassTender);

    if (this.rewardAutoLookup) {
      const hasRewardProvider = this.getTenders.some((tender) =>
        this.rewardProviders.some((provider) => +provider.paymentType === +tender.paymentType)
      );
      if (hasRewardProvider) {
        const email = this.userData?.profile?.email || this.guestUserData?.email;
        this.rewardProviders?.map((p) =>
          this.processPPIPayment({
            paymentType: +p.paymentType,
            subpaymentType: +p.subpaymentType,
            name: p.name,
            credential: email,
            checkAPIType: false
          })
        );
      }
    }

    /**
     * Persistent errors logic...
     * If there were errors added to app state then we retrieve them and set it into the local component errors
     */
    if (this.getCheckoutErrors.length) {
      this.isFormSubmitted = true;
      this.errors = this.getCheckoutErrors;
      this.resetCheckoutErrors();
    }

    trackCheckoutView(this.cartItems);
  },

  methods: {
    ...mapActions("cart", [
      "checkoutCreditCard",
      "validateCart",
      "clearPpi",
      "processCreditCardCapture",
      "processAmenityPayments",
      "initPaymentSession",
      "reInitPaymentSession",
      "checkoutOAPIApplePay",
      "checkoutMAPIApplePay",
      "connectCheckout",
      "processPpi",
      "resetURLTender"
    ]),
    ...mapActions("payments", ["getPaymentSession"]),
    ...mapActions("spinner", ["spinnerStart"]),
    ...mapMutations("cart", ["setInitElavonAP", "addCheckoutError", "resetCheckoutErrors"]),
    ...mapMutations("payments", ["setFPPaymentKey"]),
    ...mapMutations("spinner", ["requestStop"]),
    ...mapActions("user", ["fetchVisitorCreditCards"]),
    ...mapActions("messages", ["addMessage"]),
    ...mapActions("vendor", ["detectClosedVendors"]),

    clearCreditCardInformation() {
      this.cardNumber = "";
      this.expDate = "";
      this.cardEncoded = "";
      this.cardHolder = "";
      this.zipCode = "";
      this.errors = [];
      this.isFormSubmitted = false;
      this.ppiIssues = false;
      this.saveCcFlag = false;
      this.setupPaymentIssues = false;
    },

    async handleSavedCreditCardChange(userCard) {
      try {
        this.selectedUserCard = userCard;
        this.selectedSavedAccountTenders = [];
        this.walletCardError = "";
        if (CAMPUS_SUBPAYMENT_TYPES.includes(parseInt(userCard.gatewayId))) {
          this.paymentIFrame = "";
          this.selectedPayType = STORED_ACCOUNT_CARD;
        } else if (userCard.tokenCard) {
          this.paymentIFrame = "";
          this.selectedPayType = STORED_CREDIT_CARD;
          await this.setupPayment(this.selectedPayType, "", true);
        } else {
          this.selectedPayType = this.PAY_TYPE_CREDIT_DEBIT;
        }
      } catch (error) {
        this.walletCardError = "An error ocurred while attempting to retrieve card from wallet.";
      }

      this.clearCreditCardInformation();
    },

    /**
     * MAPI - nothing to set up, setupPaymentCompleted flag to true
     * OAPI - saved cards, init session for non-PPI payments
     *
     * @param selectedPayType
     * @param previousPayType
     * @param reInit
     * @returns {Promise<void>}
     */
    async setupPayment(selectedPayType, previousPayType, reInit = false) {
      if (this.APIType === MAPI_API_TYPE) {
        this.setupPaymentCompleted = true;
        return;
      }
      this.setupPaymentCompleted = false;
      this.setupPaymentIssues = false;
      
      const selectedPaymentTypes = [
        this.PAY_TYPE_APPLE_PAY,
        this.PAY_TYPE_CREDIT_DEBIT,
        this.STORED_CREDIT_CARD,
        this.PAY_TYPE_GOOGLE,
      ]
      if (this.tokenizedGatewayId === 0 && selectedPaymentTypes.includes(selectedPayType)) {
        this.errors.push(ERROR_PROCESSING_PAYMENT);
      }

      // wallet
      this.fetchVisitorCreditCards();

      if (
        ![this.PAY_TYPE_CREDIT_DEBIT, this.PAY_TYPE_APPLE_PAY, this.PAY_TYPE_GOOGLE, STORED_CREDIT_CARD].includes(selectedPayType)
      ) {
        return;
      }

      //reset iframe
      if ([this.PAY_TYPE_CREDIT_DEBIT, this.PAY_TYPE_APPLE_PAY].includes(previousPayType) && previousPayType != selectedPayType) {
        this.paymentIFrame = "";
      }

      /**
       * Build payload for initializing payment session with the current order balance, this can change when
       * a PPI card is entered and can happen also on page reload
       */
      const checkoutPayload = this.getPayload({
        balance: this.getAppliedAmenities?.balance,
        paymentType: CREDIT_CARD_PAYMENT_TYPE,
        subpaymentType: 0
      });

      const initSessionPayload = {
        selectedPayType: this.selectedPayType,
        checkoutPayload: checkoutPayload,
        successCallback: this.successfullCheckout,
        addErrorCallback: (error) => {
          this.setupPaymentIssues = true;
          //We want to keep only one error...
          this.errors = [ERROR_PROCESSING_PAYMENT];
        }
      };

      //Calls action that (re)inits payment session for the corresponding payment gateway id
      let paySession = {};
      if (reInit) {
        paySession = await this.reInitPaymentSession(initSessionPayload);
      } else {
        paySession = await this.initPaymentSession(initSessionPayload);
      }
      //populate iframe data returned from paySession
      this.paymentIFrame = this.addIDToIframe(paySession?.iframe);
      this.setupPaymentCompleted = true;
    },

    async processPPIPayment({ paymentType, subpaymentType, credential, name, buttonText, checkAPIType = true }) {
      if (checkAPIType && this.APIType === MAPI_API_TYPE) return;
      if (!paymentType || !subpaymentType || !credential) return;

      //stop auto apply when card is already applied
      if (this.getPpiAmenities.some((amenity) => amenity.card === credential)) return;

      try {
        await this.processPpi({
          tender: {
            paymentType,
            subpaymentType,
            name,
            buttonText,
            autoApplied: true
          },
          card: credential
        });

        this.cardApplied();
      } catch (error) {
        if (error !== ERROR_AMENITY_ALREADY_APPLIED) {
          this.ppiIssues = true;
          this.errors = [ERROR_APPLYING_PPI_TENDER(name, maskedCredential(credential))];
          this.resetURLTender();
          errorLoggerAdapter.createIssue(SENTRY_ERRORS.ERROR_CHECKOUT_APPLING_PPI, "ppiError", "processPpi", {
            description: JSON.stringify(error.data)
          });
        }
      }
    },

    addIDToIframe(strIframe) {
      if (!strIframe) {
        return "";
      }

      if (!FPIFrameValidation(strIframe)) return "Iframe could not be loaded";

      return strIframe
        .substring(0, strIframe.indexOf("iframe") + 6)
        .concat(` id="payment-iframe"`, strIframe.substring(strIframe.indexOf("iframe") + 6));
    },

    async setSelectedPayType(event) {
      if (!event) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      this.clearCreditCardInformation();
      if (!event.target.value) return;

      const previousPayType = this.selectedPayType;
      this.selectedPayType = event.target.value;

      await this.setupPayment(this.selectedPayType, previousPayType, true);
    },

    /**
     * Before refresh is fired it will set the store initElavonAP back to false, or the page would keep refreshing.
     * It checks for AP being enabled OAPI and Elavon.
     * This is the only piece of elavon specific code that we're not able to move from checkout and is executed conditionally
     */
    refreshPage() {
      const balance = this.getAppliedAmenities?.balance;

      if (
        this.isApplePayEnabled &&
        this.APIType === OAPI_API_TYPE &&
        this.tokenizedGatewayId === this.ELAVON_GATEWAY_ID &&
        balance > 0
      ) {
        this.setInitElavonAP(false);
        location.reload();
      }
    },

    /**
     * Processes applied payments, called on checkout
     */
    async processPayments() {
      if (this.shouldProcessPayments) {
        try {
          return await this.processAmenityPayments(this.getPaymentList());
        } catch (e) {
          return Promise.reject(e);
        }
      } else {
        return Promise.resolve();
      }
    },

    /**
     * single source for payload, we had it in a couple of places.
     */
    getPayload(payment) {
      const { fee, tip, tax, subtotalAmount, amount } = this.getCheckoutParams;

      return {
        payments: this.getPaymentList(payment),
        fee,
        tip,
        tax,
        subtotalAmount,
        amount
      };
    },

    /**
     * Main checkout, gets called from place order button, decides what checkout needs to be called.
     */
    async checkout() {
      this.errors = [];
      this.v$.$touch();
      this.isFormSubmitted = true;
      this.ppiIssues = false;

      await this.detectClosedVendors([this.activeVendor]);

      try {
        if (this.APIType === MAPI_API_TYPE) {
          const isOpen = await this.checkVendorIsOpen();
          if (!isOpen) return;
        } else {
          const isTimeStillAvailable = await this.checkIfTimeSlotIsValid();
          if (!isTimeStillAvailable) return;
        }
      } catch (error) {
        // only track errors from bad requests
        if (error) {
          errorLoggerAdapter.createIssue(SENTRY_ERRORS.ERROR_CHECKOUT, "orderAhead", "orderAhead", {
            description: JSON.stringify(error.data)
          });
        }
        return;
      }

      if (this.APIType !== MAPI_API_TYPE) {
        try {
          await this.processPayments();
        } catch (e) {
          this.cardApplied(false);
          this.errorCallback(e);
          this.ppiIssues = true;
          return;
        }
      }

      const balance = this.getAppliedAmenities?.balance;
      // checking for AP and balance
      if (this.selectedPayType === this.PAY_TYPE_APPLE_PAY && balance > 0) {
        this.applePayCheckout({
          paymentPayload: this.getPayload(null),
          onSuccess: this.successfullCheckout,
          onError: this.errorCallback,
          onCatch: this.catchCallback,
          onCancel: this.cancelCallback
        });
        return;
      }

      const paymentPayload = this.getPayload(null);
      const creditCardData = this.selectedUserCard
        ? { ...this.selectedUserCard }
        : {
            cardNumber: this.cardNumber,
            cardHolder: this.cardHolder,
            expDate: this.expDate,
            cardEncoded: this.cardEncoded,
            zipCode: this.zipCode
          };

      const processCCPayload = {
        creditCardData: creditCardData,
        saveCardToken: this.saveCcFlag
      };

      this.connectCheckout({
        paymentPayload,
        processCCPayload,
        successCallback: this.successfullCheckout,
        errorCallback: this.errorCallback,
        catchCallback: this.catchCallback,
        cancelCallback: this.cancelCallback
      });
    },

    cancelCallback() {
      this.requestStop();
    },

    FPIFrameErrorCallback() {
      this.requestStop();
    },

    async errorCallback(data) {
      this.requestStop();
      await this.setupPayment(this.selectedPayType, "", true);
      this.errors.push(data ?? ERROR_PROCESSING_PAYMENT);
    },

    async catchCallback(reject) {
      this.requestStop();
      await this.setupPayment(this.selectedPayType, "", true);

      if (this.APIType !== OAPI_API_TYPE && reject === ERROR_PROCESSING_PAYMENT) {
        // MAPI checkout error response doesn't show if the error was in PPI or the CC. Allways clear PPI
        this.clearPpi();
      }

      if (reject?.response?.status === 400 || reject?.response?.status === 422) {
        this.clearPpi();
        this.cardApplied(false);
        this.isFormSubmitted = false;
        this.ppiIssues = true;
        this.errors = [];
        this.errors.push(ERROR_PROCESSING_PPI_PAYMENTS);
        return;
      }

      this.errors.push(ERROR_PROCESSING_PAYMENT);
    },

    successfullCheckout(order) {
      this.requestStop();
      this.resetCheckoutErrors();
      this.$router.push({
        name: ROUTE_NAMES.ORDER_CONFIRMATION,
        params: {
          cartItems: this.$route.params.cartItems,
          order
        }
      });
    },

    /**
     * Routes between OAPI/MAPI apple pay checkout code
     */
    applePayCheckout(payload = {}) {
      if (this.APIType === OAPI_API_TYPE) {
        this.checkoutOAPIApplePay(Object.assign({}, payload, this.applePayMAPIPayload()));
        return;
      }

      this.checkoutMAPIApplePay(this.applePayMAPIPayload());
    },

    applePayMAPIPayload() {
      return {
        ...this.getCheckoutParams,
        payments: this.getPaymentList(),
        balance: this.getAppliedAmenities?.balance || 0,
        vendorName: this.activeVendor.name || "Order Total",
        venueId: `${this.venueId}`,
        onSuccess: this.successfullCheckout,
        onError: this.errorCallback,
        onCancel: this.cancelCallback
      };
    },

    shouldProcessPayments() {
      const payments = this.getPaymentList();
      if (!payments || !payments.length) return false;
      return !(payments.length === 1 && !payments[0].appliedAmenity);
    },

    getPaymentList(passedPayment) {
      const payments = [];
      const amenities = this.getAmenitiesInUse?.amenities;
      const balance = this.getAmenitiesInUse?.balance;

      if (passedPayment) {
        payments.push(passedPayment);
      }

      if (this.selectedPayType === this.PAY_TYPE_APPLE_PAY && this.APIType === OAPI_API_TYPE && balance > 0) {
        payments.push({
          balance,
          paymentType: CREDIT_CARD_PAYMENT_TYPE,
          subpaymentType: 0
        });
      }

      if (this.cardNumber || this.selectedUserCard) {
        payments.push({
          balance: this.getAmenitiesInUse?.balance,
          cardNumber: this.cardNumber || getMaskedCardNumber(this.selectedUserCard.lastFour),
          cardEncoded: 0,
          expDate: this.getExpDate,
          cardholderFullname: this.cardHolder || this.selectedUserCard.cardHolder
        });
      }

      if (this.tokenizedGatewayId === FREEDOMPAY_GATEWAY_ID && balance > 0 && this.APIType === OAPI_API_TYPE) {
        payments.push({
          cardNumber: this.cardNumber,
          balance
        });
      }

      if (amenities && amenities.length) {
        amenities.forEach((payment) => {
          payments.push({
            appliedAmenity: payment.appliedAmenity,
            cardNumber: payment.card,
            paymentType: payment.cardBalance.paymentType,
            subpaymentType: payment.cardBalance.subpaymentType,
            buttonText: payment.selectedTender.buttonText || payment.selectedTender.name || ""
          });
        });
      }

      return payments;
    },

    cardApplied(showNotification = true) {
      if (showNotification) this.showNotification();

      this.refreshPage();

      //If there's no balance left to pay or selected card is a stored CC then don't set any default payment option
      if (
        !this.showPaymentOptions ||
        (this.selectedUserCard && !CAMPUS_SUBPAYMENT_TYPES.includes(parseInt(this.selectedUserCard.gatewayId)))
      )
        return;

      const applePayElement = document.getElementById(this.PAY_TYPE_APPLE_PAY);
      const creditDebitPayElement = document.getElementById(this.PAY_TYPE_CREDIT_DEBIT);

      // resets to default and shows it selected.
      if (this.isApplePayEnabled) {
        applePayElement.click();
        return (this.selectedPayType = this.PAY_TYPE_APPLE_PAY);
      }

      creditDebitPayElement.click();
      this.selectedPayType = this.PAY_TYPE_CREDIT_DEBIT;
    },

    showNotification() {
      const balanceDue = roundOffByBankApproach(this.getAppliedAmenities.balance);
      if (balanceDue > 0 && this.getAmenitiesInUse.amenities.length) {
        const msgObj = {
          message: appliedPaymentMsg(balanceDue),
          componentName: AppAppliedPaymentNotifier.name
        };

        // changed to make it easier to test.
        this.addMessage(msgObj);
      }
    },

    FPPaymentKeyEventHandler(data) {
      this.cardNumber = data.attributes.find((a) => a.Key.toLowerCase() === "maskedcardnumber")?.Value || "";
      this.expDate = data.attributes.find((a) => a.Key.toLowerCase() === "expirationdate")?.Value || "";
      this.zipCode = data.attributes.find((a) => a.Key.toLowerCase() === "postalcode")?.Value || "";
      this.setFPPaymentKey(data.paymentKeys[0]);
      this.checkout();
    },

    loadGatewayScripts() {
      if (this.APIType !== OAPI_API_TYPE) return;

      switch (this.tokenizedGatewayId) {
        case this.FREEDOMPAY_GATEWAY_ID:
          break;

        case this.ELAVON_GATEWAY_ID:
        default:
          loadPaymentGatewayScripts(this.tokenizedGatewayId);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.dark {
  .checkout__button,
  .checkout__options-content,
  .checkout__options-radio {
    color: $primary-color;
    background-color: rgba($background-dark--2, 0.3);
  }

  .checkout__options-radio {
    background-color: rgba($background-dark--1, 0.3);
  }
}

.checkout {
  font-family: $fontFamilySecondary;
  min-height: calc(100vh - 80px);

  &__row {
    padding-top: 25px;

    @include respond-to-mobile {
      padding: 25px 15px;
    }
  }

  h2.iw-group-title {
    font-size: 16px;
    color: #000;
  }

  hr {
    height: 0.9px;
    background-color: rgba(121, 120, 120, 0.5);
    margin: 0;
    opacity: 0.3;
    border: 0px;
  }

  &__image-googlePay {
    margin-left: 28px;
    margin-right: 0 !important;
    background-color: #fff;
    max-height: 36px;
    width: 3em !important;
  }

  &__googlePayContainer {
    display: flex;
    align-items: center;
  }

  &__header {
    @include respond-to-mobile {
      min-height: 5em;
      background-color: $border-color;
    }
  }

  &__options {
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &-title {
      margin-top: 20px;
    }

    &-wallet-title {
      margin: 1.5rem 0;
    }

    &-favoriteCcs-options {
      hr {
        margin: 20px 0;
      }
    }

    &-option {
      font-weight: bold;
      display: flex;
      flex-direction: column;
    }

    &-content {
      border-radius: 5px;
      background: $group-3-color-3-alpha-08;
    }

    &-radio {
      display: flex;
      align-items: center;
      background-color: $primary-color;

      img {
        margin-right: 0.5rem;
        width: 1.3em;
      }
    }
  }

  &__container {
    margin: 5px 0 24px;

    @include respond-to-mobile {
      margin-top: 10px;
    }

    h1,
    h2 {
      font-size: 20px;
      line-height: 24px;
    }
  }

  &__collection {
    width: 100%;
  }

  &__description {
    color: $text-color;
  }

  &__save-wallet {
    font-weight: normal;

    input {
      transform: scale(1.25);
    }

    input {
      opacity: 0;
      width: 1em;
      height: 1em;
    }

    label {
      padding-left: 4px;
    }
  }

  &__title,
  &__description,
  &__link {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  &__link {
    align-self: flex-start;
  }

  &__input {
    border-color: $border-color-secondary;

    &_error {
      border-color: $error-color !important;
    }
  }

  &__card {
    margin: 13px 23px 22px 22px;
  }

  &__section {
    display: flex;
    justify-content: space-between;

    &_column {
      flex-direction: column;
    }
  }

  &__wrap-section {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &_column {
      flex-direction: column;
      width: 30%;

      @include respond-to-mobile {
        width: 40%;
      }
    }
  }

  &__image {
    max-height: 30px;
  }

  &__footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  &__footer-links {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 34px;
  }

  &__button {
    height: 46px;
  }

  &__error {
    box-sizing: border-box;
    margin-bottom: 10px;
    padding: 10px 0 10px 20px;
    justify-content: flex-start;
    text-transform: none;
    font-family: $fontFamilyPrimary !important;

    @include respond-to-mobile {
      flex-direction: row;
      height: initial;
      padding: 10px 20px;
    }
  }

  &__summary {
    & > * {
      padding: 0;
      margin: 0;
      font-weight: bold;
      background-color: $primary-color;
    }

    & > .shopping-cart-total {
      width: 100%;

      @include respond-to-mobile {
        padding-top: 1em;
        min-width: unset;
      }
    }
  }
}

.expDate__error {
  font-family: $fontFamilyPrimary !important;
  font-size: 12px;
  position: relative;
  bottom: 10px;
  left: 5px;
}

.dark {
  color: #000;
}

img.credit_card {
  background-color: #fff;
}

.checkbox {
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 0.5em;
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  color: $group-3-color-2;
  align-items: center;

  &--disabled {
    opacity: 0.4;
  }
}

.back-button-text {
  font-size: 14px;
  font-weight: bold;
  vertical-align: top;
}

.checkbox__control {
  display: inline-grid;
  width: 22px;
  height: 22px;
  border-radius: 3px;
  border: solid 0.6px rgba(141, 154, 174, 0.4);

  svg {
    margin: auto;
    width: 16px;
    height: 16px;
    border-radius: 1px;
    transform: scale(0);
    transform-origin: bottom left;
  }
}

.checkbox__input {
  display: grid;
  grid-template-areas: "checkbox";

  > * {
    grid-area: checkbox;
  }

  input {
    opacity: 0;
    width: 1em;
    height: 1em;

    &:checked + .checkbox__control svg {
      transform: scale(1);
      color: $group-3-color-1;
      background: $group-3-color-4;
    }

    &:disabled + .checkbox__control svg {
      color: $group-3-color-1;
      background: $group-3-color-3;
    }
  }
}

.order-details {
  padding: 15px 0;
}

.error-container {
  display: flex;
  margin-top: -2px;
}

.error-message {
  color: $error-color;
  margin-left: $spacer * 0.5;
  font-weight: normal;
  font-size: 14px;
}

.wallet-card-content {
  padding: 15px;
  margin: 15px 0 0 15px;
  border-radius: 5px;
  background: $group-3-color-3-alpha-08;
}
</style>
